import { PlusIcon } from '@heroicons/react/20/solid'
function classNames(...classes) {return classes.filter(Boolean).join(' ')}

export const ButtonWithLeadingIconMedium = ({text, color, action}) => {
  return (
    <>
      <button
        type="button"
        onClick={action}
        className={classNames(`inline-flex items-center justify-center cursor-pointer gap-x-1.5 rounded-md ${color} w-full text-black px-2.5 py-1.5 text-sm font-semibold border-none shadow-sm hover:bg-${color}-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-${color}-600`)}
      >
        <PlusIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
        {text}
      </button>
    </>
  )
}
export const ButtonWithLeadingIconLarge = ({text, color, action}) => {
    return (
      <>
        <button
          type="button"
          onClick={action}
          className={classNames(`inline-flex items-center justify-center cursor-pointer gap-x-1.5 rounded-md ${color} w-full text-black px-3 py-2 text-sm font-semibold border-none shadow-sm hover:bg-${color}-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-${color}-600`)}
        >
          <PlusIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
          {text}
        </button>
      </>
    )
  }
export const ButtonWithLeadingIconXLarge = ({text, color, action}) => {
  return (
    <>
      <button
        type="button"
        onClick={action}
        className={classNames(`inline-flex items-center justify-center cursor-pointer gap-x-2 rounded-md ${color} w-full text-black px-3.5 py-2.5 text-sm font-semibold border-none shadow-sm hover:bg-${color}-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-${color}-600`)}
      >
        <PlusIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
        {text}
      </button>
    </>
  )
}